<template>
  <div
    id="userLayout"
    :class="['user-layout-wrapper', isMobile && 'mobile']"
  >
    <div class="container">
      <!-- <div class="top">
        <div class="header">
          <a href="/">
            <img
              src="~@/assets/logo.png"
              class="logo"
              alt="logo"
            >
            <span class="title">XXX后台管理系统</span>
          </a>
        </div>
        <div class="desc">
        </div>
      </div> -->
      <router-view />

    </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'

export default {
  name: 'UserLayout',
  mixins: [deviceMixin],
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;

  &.mobile {
    .container {
      .main {
        // max-width: 368px;
        // width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    min-height: 100%;
    // background: url(~@/assets/images/bei.png) no-repeat;
    // background-size: 100% 100%;
    // padding: 110px 0 144px;
    // position: relative;

    a {
      text-decoration: none;
    }

    .top {
      text-align: center;

      .header {
        height: 44px;
        line-height: 44px;

        .badge {
          position: absolute;
          display: inline-block;
          line-height: 1;
          vertical-align: middle;
          margin-left: -12px;
          margin-top: -10px;
          opacity: 0.8;
        }

        .logo {
          height: 44px;
          vertical-align: top;
          margin-right: 16px;
          border-style: none;
        }

        .title {
          font-size: 33px;
          color: rgba(0, 0, 0, .85);
          font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }

      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }

    // .main {
    //   min-width: 260px;
    //   width: 368px;
    //   margin: 0 auto;
    // }
    .container_c {
      position: absolute;
      top: 349px;
      left: 256px;
      color: #fff;
      font-size: 32px;

      div {
        margin-bottom: 16px;
        font-size: 56px;
        font-weight: bold;
      }
    }

    .footer {
      position: absolute;
      width: 100%;
      bottom: 46px;
      text-align: center;
      color: #fff;
      font-size: 14px;

      .links {
        margin-bottom: 8px;
        font-size: 14px;

        a {
          color: rgba(0, 0, 0, 0.45);
          transition: all 0.3s;

          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }

      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }
  }
}
</style>
